export default __webpack_public_path__ + "app/views/valueseries/valueseries.html";